import { success } from '@redux-requests/core';
import { combineReducers, AnyAction } from 'redux';

import { IndexableObjectType } from 'shared/types/common';

import { Source } from 'shared/types/source';

import * as actions from './actions';
import { SourceToViewAction } from './types';

const sourceMappingsReducer = (state: IndexableObjectType = {}, action: AnyAction) => {
  const {payload, response} = action;
  
  switch (action.type) {
    case success(actions.FETCH_SOURCE_MAPPINGS):
      return response;
    default:
      return state;
  }
};

const sourceToViewReducer = (state: Partial<Source> = {}, action: SourceToViewAction) => {
  switch (action.type) {
    case actions.SET_SOURCE_TO_VIEW:
      return action.payload.sourceToView;
    default:
      return state;
  }
};

const sourceReducer = combineReducers({
  sourceToView: sourceToViewReducer,
  sourceMappings: sourceMappingsReducer,
});

export default sourceReducer;
